import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS, DRAFTING_HISTORY_ENDPOINTS } from "../apiEndpoints";

const backendUrl = BACKEND_ENDPOINTS.BASE_URL;

export const saveDraftingHistoryApi = (docType, payload) =>
  apiClient.post(
    `${backendUrl}${DRAFTING_HISTORY_ENDPOINTS[docType].SAVE}`,
    payload
  );

export const getDraftingHistoryApi = (docType, userId) =>
  apiClient.post(`${backendUrl}${DRAFTING_HISTORY_ENDPOINTS[docType].GET}`, {
    user_id: userId,
  });

export const updateDraftingHistoryFlagsApi = (docType, payload) =>
  apiClient.put(
    `${backendUrl}${DRAFTING_HISTORY_ENDPOINTS[docType].UPDATE_FLAGS}`,
    payload
  );

export const updateDraftingHistoryDocumentApi = (docType, payload) =>
  apiClient.put(
    `${backendUrl}${DRAFTING_HISTORY_ENDPOINTS[docType].UPDATE_DOCUMENT}`,
    payload
  );

export const deleteDraftingHistoryApi = (docType, payload) =>
  apiClient.delete(
    `${backendUrl}${DRAFTING_HISTORY_ENDPOINTS[docType].DELETE}`,
    payload
  );
